module.exports = __webpack_public_path__ + "static/media/visored-helm.1f2ced7f.svg";